import { memoize } from '../../utils';

/**
 * Gets the whiteboard store via an awaited import to facilitate lazy loading
 * the tldraw package within hooks
 */
export const loadWhiteboardStore = memoize(async function getStore() {
  return (await import('./appWhiteboardStore')).default;
});
